import React, { useEffect, useState, useContext } from 'react';
import { Link, useParams } from "react-router-dom";

import PgLivesItem from './PgLivesItem.jsx'
import CompActive from '../components/CompActive.jsx';
import { MdSearch, MdAdd } from "react-icons/md";
import { data_live } from '../api/datalive'
import { validarME } from '../api/apiMe'

import { MeuContexto } from "../App"

import { global } from '../api/global'

let listacompleta = []
let pagenumber = 1
let vrfilter = ''
let vrmeusartistas = false
let novofilter = ''

function PgLives() {
    let { Procura } = useParams();
    vrfilter = Procura

    if (vrfilter == 'Procurar') vrfilter = ''
    const { setlogado, setusername, setuser } = useContext(MeuContexto)

    const [isloading, setisloading] = useState(true);
    const [liveson, setliveson] = useState([])
    const [livestrailer, setlivestrailer] = useState([])
    const [filter, setFilter] = useState(vrfilter);
    const [slide, setSlide] = useState(0);

    useEffect(
        () => {
            _carregatela()
        }, [])

    async function _carregatela() {
        const me = await validarME.me()
        if (me) {
            setuser(me)
            setusername(me.username)
            setisloading(false)
            setlogado(true)
        } else {
            setuser([])
            setisloading(false)
            setlogado(false)
        }

        Atualizar(1)
    }

    function _filtrar(e) {
        e.preventDefault()
        Atualizar(1)
    }

    async function Atualizar(page) {
        setisloading(true)

        AtualizarTrailer()

        pagenumber = page

        if (page === 1) {
            listacompleta = []
        }

        novofilter = ''

        if (vrmeusartistas) { novofilter = 'meusartistas' } else { novofilter = filter }

        const rlista1 = await data_live.Listar(global.brl.REACT_APP_LISTAID, page, novofilter);
        if (rlista1) {
            listacompleta = [...listacompleta, ...rlista1]

            if (rlista1.length < 10) {
                await Atualizar1(page)
            }
            else {
                Atualizar1(1)
            }
        }
        setliveson(listacompleta)

        setisloading(false)
    }

    async function Atualizar1(page) {
        const rlista2 = await data_live.Listar1(global.userid, page, novofilter);

        if (rlista2) {
            listacompleta = [...listacompleta, ...rlista2]

            if (rlista2.length < 10) {
                await Atualizar2(page)
            }
            else {
                Atualizar2(1)
            }
        }
    }

    async function Atualizar2(page) {
        const rlista3 = await data_live.Listar2(global.userid, page, novofilter);

        if (rlista3) {
            listacompleta = [...listacompleta, ...rlista3]
        }
    }

    async function AtualizarTrailer() {
        const rlistatrailer = await data_live.Trailer();

        if (rlistatrailer) {
            setlivestrailer(rlistatrailer)
        }
    }

    function _proximapg(e) {
        e.preventDefault()
        pagenumber++
        if (!isloading) { Atualizar(pagenumber) }
    }

    return (
        <main className="min-h-screen bg-background text-white">
            <div className="max-w-7xl mx-auto px-3 md:px-6 lg:px-8 py-4 md:py-8">
                {/* Header */}
                <div className="text-center mb-6 md:mb-8">
                    <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-2 md:mb-4">
                        Lives & Eventos
                    </h1>
                    <p className="text-gray-400 text-base md:text-lg">
                        Descubra apresentações ao vivo e eventos especiais
                    </p>
                </div>

                {/* Search Form */}
                <div className="flex justify-center mb-6 md:mb-8">
                    <form 
                        onSubmit={(e) => { _filtrar(e) }} 
                        autoComplete="off"
                        className="flex items-center gap-3 md:gap-4 w-full max-w-md"
                    >
                        <div className="relative flex-1">
                            <input
                                autoComplete="off"
                                placeholder="Localizar artista ou evento"
                                name="localizar"
                                type="text"
                                value={filter}
                                onChange={e => setFilter(e.target.value)}
                                className="w-full px-4 py-2.5 md:py-3 bg-gray-800 border-2 border-gray-600 rounded-xl text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent transition-all duration-200 text-sm md:text-base"
                            />
                        </div>
                        
                        <button
                            type="submit"
                            className="flex items-center justify-center w-10 h-10 md:w-12 md:h-12 bg-teal-600 hover:bg-teal-500 rounded-xl transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-teal-500"
                            aria-label="Buscar"
                        >
                            <MdSearch className="text-white text-lg md:text-xl" />
                        </button>
                    </form>
                </div>

                {/* Lives Grid */}
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-6 mb-6 md:mb-8">
                    {liveson.map((item) => (
                        <Link 
                            key={item._id} 
                            to={`/Canal/${item.linktoken}`}
                            className="block transform hover:scale-105 transition-transform duration-200 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:ring-offset-2 focus:ring-offset-slate-950 rounded-xl"
                        >
                            <PgLivesItem item={item} />
                        </Link>
                    ))}
                </div>

                {/* Load More Button */}
                {liveson.length > 0 && (
                    <div className="flex justify-center mb-6 md:mb-8">
                        <button
                            onClick={(e) => { _proximapg(e) }}
                            disabled={isloading}
                            className="flex items-center justify-center w-14 h-14 md:w-16 md:h-16 bg-gray-800 hover:bg-gray-700 border-2 border-gray-600 hover:border-teal-500 rounded-full transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-teal-500 disabled:opacity-50 disabled:cursor-not-allowed"
                            aria-label="Carregar mais"
                        >
                            <MdAdd className="text-white text-xl md:text-2xl" />
                        </button>
                    </div>
                )}

                {/* Empty State */}
                {!isloading && liveson.length === 0 && (
                    <div className="text-center py-12 md:py-16">
                        <div className="bg-gray-800/50 rounded-2xl p-6 md:p-8 max-w-md mx-auto">
                            <h3 className="text-lg md:text-xl font-semibold text-gray-300 mb-2">
                                Nenhum resultado encontrado
                            </h3>
                            <p className="text-gray-400 text-sm md:text-base">
                                Tente ajustar os filtros ou pesquisar por outro termo
                            </p>
                        </div>
                    </div>
                )}

                {/* Loading State */}
                {isloading && liveson.length === 0 && (
                    <div className="flex justify-center py-12 md:py-16">
                        <CompActive />
                    </div>
                )}
            </div>
        </main>
    )
}

export default PgLives